//import { globalSettings } from "../../helpers/settings";

const str = '';
const dateTimeStr = new Date()?.toISOString();
//const localDecimal = 0.00;

export const commonAreaModelGet = ({ id = '', userId = '', }) => {
    return {
        id: id,
        userId: userId,
        created: dateTimeStr,
        area: str,
        remark: str,
    }
};